import React, { forwardRef } from 'react';

const FormField = forwardRef(({ 
  label, 
  name, 
  register, 
  errors, 
  type = 'text', 
  required = false,
  options = [],
  placeholder = '',
  className = ''
}, ref) => {
  return (
    <div className={`form-group ${className}`}>
      <label htmlFor={name} className="block text-sm font-medium mb-1">
        {label} {required && <span className="text-accent">*</span>}
      </label>
      
      {type === 'select' ? (
        <select
          id={name}
          className={`input-field ${errors[name] ? 'border-accent' : ''}`}
          {...register(name)}
          defaultValue=""
        >
          <option value="" disabled>{label} - vyberte prosím</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          id={name}
          className={`input-field min-h-[100px] ${errors[name] ? 'border-accent' : ''}`}
          placeholder={placeholder}
          {...register(name)}
        />
      ) : (
        <input
          id={name}
          type={type}
          className={`input-field ${errors[name] ? 'border-accent' : ''}`}
          placeholder={placeholder}
          ref={ref}
          {...register(name)}
        />
      )}
      
      {errors[name] && (
        <p className="error-message">{errors[name].message}</p>
      )}
    </div>
  );
});

FormField.displayName = 'FormField';

export default FormField;
